import React from 'react';
import { Row, Col, Spin, Checkbox, Radio } from 'antd';
import { 
    textEllipsis, 
    getMenuWidth,
    getWinSize 
} from '@/utils/common';
import BaseComponent from 'components/BaseComponent';
import PictureShow from 'components/PictureShow';
import Icon from 'components/Icon';
import '@/routes/Material/Util/index.less';
import CSSAnimate from 'components/CSSAnimate';
import $$ from 'cmn-utils';
const RadioGroup = Radio.Group;
export class MaterialGraphComponent extends BaseComponent {
    state = {
        currentEle: null
    }

    /** 素材被选中勾选 */
    onCheckboxChange = (e, ele) => {
        this.setState({
            currentEle: ele
        })
        if (e) {
            e.preventDefault;
            e.stopPropagation;
        }
        let rows = this.props.checkRows;
        let keys = this.props.checkKeys;
        let rowsFindIndex = rows.findIndex(val => val.id === ele.id);
        if (rowsFindIndex !== -1) {
            rows.splice(rowsFindIndex, 1);
            keys.splice(rowsFindIndex, 1);
        } else {
            rows = [...rows, ele];
            keys = [...keys, ele.id];
        }
        this.props.onMaterialChecked(rows, keys);
    }

    /** 单选选中时 */
    onRadioChecked = (e, ele) => {
        if (ele) {
            this.props.onMaterialChecked([ele], [ele.id]);
        } else {
            const { material: { pageData } } = this.props;
            let key = e.target.value;
            let row = {};
            let list = pageData.list;
            for (let item of list) {
                if (item.id === key) {
                    row = item;
                    break;
                }
            }
            this.props.onMaterialChecked([row], [key]);
        }
    }

    render() {
        const authCodes = $$.getStore('authCodes');//按钮权限代码列表
        if (!authCodes) return null;
        const { currentEle } = this.state;
        const { 
            material: { pageData }, 
            parentOrgIds,
            checkKeys, 
            typeData: { currentType, isShare }, 
            selectType, 
            loading, 
            buttonAuth,
            onDoubleClickData, 
            onShowAddFolder, 
            onDeleteFile, 
            onShowAddLive, 
            onShareFile, 
            onShowPreviewHandler, 
            onShowRename,
            onShowRss,
            onDownloadMaterial,
            onCheckedMaterialData, 
            materialSize,
        } = this.props;
        
        /* 加载数据 */
        let allElement = pageData.list.map((ele) => {
            let nameSuffix = ele.name;              // 名称带后缀
            let src = "assets/images/material/material-default.jpg";                           // 加载图片地址
            let sense = "320x240";                  // 图片分辨率
            let id = ele.id;                        // 图片id    
            let isChecked = false;                  // 是否选中
            let scope = ele.scope;                  // 文件夹
            let isShareStatus = ele.is_share;       // 该元素是否被分享
            let shareParam = { tipMsg: '', iconMsg: '' };
            if (isShareStatus === '0') {
                shareParam.tipMsg = window.language['material.share'];
                shareParam.iconMsg = 'share-o';
            } else {
                shareParam.tipMsg = window.language['material.cancelShare'];
                shareParam.iconMsg = 'share-no-o';
            }
            
            if (ele.suffix) {
                nameSuffix += '.' + ele.suffix;
            }

            if (checkKeys.length !== 0) {
                for (let key of checkKeys) {
                    if (id === key) {
                        isChecked = true;
                        break;
                    }
                }
            }
            if (scope) {   // 文件夹
                src = 'assets/images/material/material-folder.png';
                sense = '143x106';
            } else {
                if (currentType === '0') {   // 视频
                    /**
                     * 0：原视频处理转换中 
                     * 1：原视频处理正常 
                     * 2：原视频处理转换失败
                     * 3：转换成符合固件的视频完成,flv转换未完成
                     * 4：转换flv完成,但适合终端播放的MP4格式的转换未完成
                     * 5：该视频能在终端上播放,但是生成flv失败
                     */
                    if (ele.status === '1') {
                        src = ele.preview;
                        sense = "320x240";
                    }
                    
                } else if (currentType === '1') {  // 图片
                    src = ele.preview;
                    sense = ele.preview_sense;
                } else if (currentType === '2') {  // 音乐
                    src = 'assets/images/program/music.png';
                    sense = '102x106';
                } else if (currentType === '7') { // 网页
                    src = 'assets/images/program/web.png'
                    sense = '102x106';
                } else if (currentType === '18') { // RSS
                    src = 'assets/images/program/rss.png',
                    sense = '102x106';
                } else if (currentType === '15' || currentType === '16' || currentType === '17' || currentType === '35') {  // word、excel、ppt、pdf
                    let previewList = ele.previewList;
                    if (previewList && previewList.length > 0) {
                        src = previewList[0].path;
                        sense = previewList[0].sense;
                    }
                }
            }
            // 显示素材数据
            let data = {
                id,
                name: nameSuffix,
                src: src,
                sense: sense,
                status: ele.status,
                scope: ele.scope,
                type: currentType,
            }

            let addLi = null;
            let previewLi = null;
            let findLi = null;
            let showDownloadLi = null;
            if (authCodes[buttonAuth[1]]) {
                if (currentType === '7') {
                    addLi = <li title={window.language['common.update']} onClick={(e) => { onShowAddLive(e, '1', ele) }}><Icon className="edit-o" /></li>
                } else if (currentType === '18') {
                    addLi = <li title={window.language['common.update']} onClick={(e) => { onShowRss(e, '1', ele) }}><Icon className="edit-o" /></li>
                } else {
                    addLi = <li title={window.language['common.update']} onClick={(e) => { onShowRename(e, ele) }}><Icon className="edit-o" /></li>
                }
            }

            if (currentType === '7') {//网页
                findLi = <li title={window.language['material.view']} onClick={(e) => { onShowAddLive(e, '2', ele) }}><Icon className="preview-o" /></li>
            } else if (currentType === '18') {//RSS
                findLi = <li title={window.language['material.view']} onClick={(e) => { onShowRss(e, '2', ele) }}><Icon className="preview-o" /></li>
            } else {
                previewLi = <li title={window.language['material.preview']} onClick={ (e) => { onShowPreviewHandler(e, ele) }}><Icon className="preview-o" /></li>
                if (authCodes[buttonAuth[9]]) {
                    showDownloadLi = <li title={window.language['common.download']} onClick={ (e) => { onDownloadMaterial(e, ele) }}><Icon className="material-download-list" /></li>
                }
            }
            
            let shareNode = null; 

            if (isShare === '1') { //共享素材页面
                let operShare = null;
                if (authCodes[buttonAuth[6]]) {
                    operShare = (
                        <li title={shareParam.tipMsg} onClick={(e) => { onShareFile(e, isShareStatus, ele) }}>
                            <Icon className={shareParam.iconMsg} />
                        </li>
                    );
                }
                if (parentOrgIds && parentOrgIds.length > 0) {
                    let arr = parentOrgIds.split(",");
                    let index = arr.indexOf(ele.org.id); 
                    if (index !== -1) {
                        operShare = null;
                    }
                }
                shareNode = (
                    <div className={isChecked ? 'material-div-tool' : 'material-div-tool-disable'}>
                        <ul>
                            {previewLi}
                            {findLi}
                            {showDownloadLi}
                            {operShare}
                        </ul>
                    </div>
                );
            } else { //我的素材页面
                let ulNode = null;
                
                if (!scope) { // 素材
                    ulNode = (
                        <ul>
                            {addLi}
                            {authCodes[buttonAuth[2]] ? (
                            <li title={window.language['common.del']} onClick={(e) => { onDeleteFile(e, ele) }}><Icon className="delete-o" /></li>
                            ) : null}
                            {previewLi}
                            {showDownloadLi}
                            {authCodes[buttonAuth[6]] ? (
                            <li title={shareParam.tipMsg} onClick={(e) => { onShareFile(e, isShareStatus, ele) }}><Icon className={shareParam.iconMsg} /></li>
                            ) : null}
                        </ul>
                    );
                } else { // 文件夹
                    ulNode = (
                        <ul>
                            {authCodes[buttonAuth[5]] ? (
                            <li title={window.language['material.folder.editFolder']} onClick={(e) => { onShowAddFolder(e, '1', ele) }}><Icon className="edit-o" /></li>
                            ) : null}
                            {authCodes[buttonAuth[3]] ? (
                            <li title={window.language['common.del']} onClick={(e) => { onDeleteFile(e, ele) }}><Icon className="delete-o" /></li>
                            ) : null}
                        </ul>
                    );
                }
                shareNode = (
                    <div className={isChecked ? 'material-div-tool' : 'material-div-tool-disable'}>
                        {ulNode}
                    </div>
                )
            }
            let textLength = 16;
            if(getWinSize().winWidth >= 1920){
            } else if(getWinSize().winWidth >= 1440){
                textLength = 10;
            } else if(getWinSize().winWidth >= 1366){
                textLength = 10;
            } else if(getWinSize().winWidth >= 1280){
                textLength = 8;
            } else {
                textLength = 5;
            }
            let textName = textEllipsis(nameSuffix, textLength);
            return (
                <Col key={id} className={`material-col ${isChecked ? 'material-check-col' : ''}`}>
                    <div className="material-col-top">
                        <div onClick={(e) => {
                                e.persist();
                                if (selectType === '0') {
                                    this.onCheckboxChange(e, ele);
                                } else {
                                    this.onRadioChecked(e, ele);
                                }
                            }}
                            onDoubleClick={(e) => {
                                e.persist();
                                onCheckedMaterialData && onCheckedMaterialData(ele);
                                onDoubleClickData && onDoubleClickData(e, ele);
                            }}
                        >
                            <PictureShow data={data}/>
                        </div>
                        <div className={`material-checkbox ${isChecked ? 'material-checkbox-flow' : 'material-checkbox-default'}`}>
                            { selectType === '0' ? (
                                <Checkbox checked={isChecked} 
                                    onChange={(e) => {
                                        this.onCheckboxChange(e, ele);
                                    }}
                                >
                                    {textName}
                                </Checkbox>
                            ) : (
                                <Radio value={id}>
                                    {textName}
                                </Radio>
                            )}
                        </div>
                        <CSSAnimate key={id} type={ (currentEle && currentEle.id === id) ? "fadeInDown" : "" } duration={500}>
                            {shareNode}
                        </CSSAnimate>
                    </div>
                </Col>
            )
        });

        // 单选时，选中的值
        let radioValue = 0;
        if (checkKeys.length > 0) {
            radioValue = checkKeys[0];
        }
        let materialStyle = {};
        if (materialSize.offsetWidth) {
            materialStyle.width = parseInt(materialSize.offsetWidth / getMenuWidth("materialMaxWidth")) * getMenuWidth("materialMaxWidth")
        }
        return (
            <Spin spinning={loading}>
                <div className="material-body-content" style={materialStyle}>
                    {
                        allElement && allElement.length > 0 ? (
                            selectType === '0' ? (
                                <Row>{allElement}</Row>
                            ) : (
                                <RadioGroup style={{ width: '100%' }} name="material-radio" 
                                    onChange={(e) => {
                                        this.onRadioChecked(e);
                                    }}
                                    value= {radioValue}
                                >
                                    <Row>{allElement}</Row>
                                </RadioGroup>
                            )
                        ) : <div style={{height: 44, lineHeight: 44}}>{window.language['material.nodata']}</div>
                    }
                </div>
            </Spin>
        )
    }

}




// WEBPACK FOOTER //
// ./src/routes/Material/Util/components/materialGraphComponent.js